import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import BtnComponent from '../buttonComponent/BtnComponent';
import SecondaryBtnComponent from '../buttonComponent/SecondaryBtnComponent';
import { Grid } from '@mui/material';
import Chip from '@mui/material/Chip';

function UpcomingBillsCard(props) {
  return (
    <div>
      <Card sx={{ width: '340px', height: '176px', borderRadius: ' 8px' }}>
        <CardContent>
          <Typography
            sx={{ fontSize: 16, fontWeight: 500, lineHeight: '24px' }}
            gutterBottom>
            {props.cardData.title}
          </Typography>

          <Grid container spacing={2} sx={{mt:'5px'}} >
            <Grid
              item
              xs={2.5}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}>
              <Typography
                sx={{
                  lineHeight: '24px',
                  fontSize: 18,
                  fontWeight: 500,
                }}>
                {props.cardData.amount}
              </Typography>
            </Grid>

            <Grid
              item
              xs={5}
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <Chip
                sx={{
                  height: '16px',
                  background: ' #FFE1AF',
                  border: '1px solid #FF9500',
                  boxSizing: ' border-box',
                  borderRadius: '24px',
                  textTransform: 'uppercase',
                  fontSize: 11,
                }}
                label={props.cardData.orangeLabel}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            marginTop: '15px'
          }}>
          <SecondaryBtnComponent
            title={props.cardData.secondaryBtnTitle}
            sx={{
              width: ' 150px',
              height: ' 40px',
              padding: '8px 24px',
              fontSize: '16px',
            }}
          />
          <BtnComponent
            title={props.cardData.primaryBtnTitle}
            sx={{
              width: ' 150px',
              height: ' 40px',
              padding: ' 8px 24px',
              fontSize: '16px',
            }}
          />
        </CardActions>
      </Card>
    </div>
  );
}

export default UpcomingBillsCard;
